// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6901e9f9","239":"f201ed1f","455":"69c36736","884":"e51ef6e1"}[chunkId] + ".chunk.js";
};